"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentsAddCommissionToAmount = void 0;
const paymentsAddCommissionToAmount = (amount, commission) => {
    let value = amount * 100;
    if (commission) {
        const divider = (1000 - commission * 10) / 1000;
        value = value / divider;
    }
    value = Math.round(value) / 100;
    return value;
};
exports.paymentsAddCommissionToAmount = paymentsAddCommissionToAmount;
//# sourceMappingURL=payments.util.js.map